import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { STICKY_CTA } from "@/constants/testIds";

export default function StickyEnquireCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // if (!visible) return null;
  // return (
  //   <Link
  //     to="/contact"
  //     data-testid={STICKY_CTA}
  //     aria-label="Enquire now"
  //     className="fixed left-5 bottom-5 z-40 hidden lg:inline-flex items-center gap-2 rounded-full bg-royal-deep px-5 py-3 text-sm font-semibold text-white shadow-[0_18px_40px_-12px_rgba(15,42,115,0.55)] hover:-translate-y-0.5 transition-transform"
  //   >
  //     <MessageCircle size={14} /> Enquire Now
  //   </Link>
  // );
}
